import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AccessTimeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"access_time"}/>
}
